var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CarouselSlide',{staticClass:"orders-statistics"},[_c('img',{attrs:{"src":"/images/promo/interface-slider/orders-statistics-slide.png","alt":"Orders statistics interface"}})])}
var staticRenderFns = []

export { render, staticRenderFns }